module.exports = window["braintree"]["venmo"];